import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { getPayoutLinksTableColumns, payoutLinksFilterNodes } from './constants';
import { BulkUploadModal, ContentCard, PaginationKaBaap, PayoutLinkModal } from '../../Common';
import { EaseTable } from '../../../libs/EaseTable';
import { connect } from 'react-redux';
import { PayoutLink } from '../../../models';
import { alertify, generate_query_set, handleApiExceptions } from '../../../app_methods';
import { Alert, Badge, Button, Descriptions, Icon } from 'antd';
import { PayoutLinkDetails } from './details';
import { EaseDrawer } from '../../../libs/EaseDrawer';
import { PAYOUT_LINK_STATUS_TYPES } from '../../../constants';
import { Text4 } from '../../../styles';
import { CreatePermissionHoc, PermissionHoc } from '../../HOC';
import FileSaver from 'file-saver';

const CreatePermissableButton = PermissionHoc(Button, "PAYOUT_LINKS_WRITE", { is_component: true, fallbackComponent: null });

const PayoutLinkList = (props) => {
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [pagination, setPagination] = useState({
        pageSize: 15,
        current: 1,
        hasNext: true,
        showing: { from: 1, to: 15 }
    });
    const [filters, setFilters] = useState({});
    const [showPayoutLinkModal, setShowPayoutLinkModal] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [payoutLinks, setPayoutLinks] = useState([]);
    const [selectedPayoutLink, setSelectedPayoutLink] = useState({});
    const [showPayoutLinkDetailsDrawer, setShowPayoutLinkDetailsDrawer] = useState(false);
    const [isDeactivating, setIsDeactivating] = useState(false);
    const [showStatusInfoDrawer, setShowStatusInfoDrawer] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    

    const prepFilters = (filters) => {
        let _filters = { ...filters };
        if (_filters.created_at && _filters.created_at.length) {
            _filters.created_at_start = _filters.created_at[0].format("YYYY-MM-DD");
            _filters.created_at_end = _filters.created_at[1].format("YYYY-MM-DD");
            delete _filters.created_at;
        }
        return _filters;
    };

    const fetchPayoutLinks = async (_pagination=pagination, _filters=filters) => {
        if (!props.current_user.key) return;
        setIsTableLoading(true);
        const response = await PayoutLink.list_v2({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ...prepFilters(_filters) });
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        let queryset = generate_query_set(PayoutLink, response.data.results);
        // queryset = queryset.map((link) => { return { ...link, is_submerchant:!!_filters.submerchant_id, submerchant: _filters.submerchant_id}})
        if (selectedPayoutLink.id) setSelectedPayoutLink(queryset.find(payoutLink => payoutLink.id == selectedPayoutLink.id));
        setPayoutLinks(queryset);
        setPagination({ ..._pagination, ...response.data.pagination });
        setIsTableLoading(false);
    };

    const deactivateLink = async (record) => {
        setIsDeactivating(true);
        const response = await record.deactivate();
        if (!response.success) {
            setIsDeactivating(false);
            handleApiExceptions(response);
            return;
        }
        alertify("Success", "Payout Link deactivated successfully.", "success");
        setIsDeactivating(false);
        togglePayoutLinkDetailsDrawer();
        fetchPayoutLinks();
    }

    const downloadReport = async () => {
        setIsDownloading(true)
        const prepedfilters=prepFilters(filters)
        const response = await PayoutLink.downloadReport(prepedfilters);
        setIsDownloading(false)
        if (!response?.data?.type) {
            handleApiExceptions(response);
            return;
          }
        FileSaver.saveAs(response.data, `PayoutLink_Report.csv`);
        
      };

    const togglePayoutLinkModal = () => {
        setShowPayoutLinkModal(!showPayoutLinkModal);
    };

    const toggleBulkUploadModal = () => {
        setShowBulkUploadModal(!showBulkUploadModal);
    };

    const togglePayoutLinkDetailsDrawer = (obj = {}) => {
        setSelectedPayoutLink(obj);
        setShowPayoutLinkDetailsDrawer(!showPayoutLinkDetailsDrawer);
    };

    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let _pagination = tableInfo.pagination;
        if (tableInfo.trigger == "filters") _pagination.current = 1;
        setPagination(_pagination);
        setFilters(tableInfo.filters);
        fetchPayoutLinks(_pagination, tableInfo.filters);
    };

    const tableColumns = getPayoutLinksTableColumns({ togglePayoutLinkDetailsDrawer, setShowStatusInfoDrawer });
    // const tableFilters = payoutLinksFilterNodes(props.current_user);
    const tableFilters = payoutLinksFilterNodes;


    useEffect(() => {
        props.onChildMount();
        let defaultFilters = {};
        tableFilters.forEach(f => defaultFilters[f.field] = f.defaultValue);
        setFilters({ ...filters, ...defaultFilters });
        fetchPayoutLinks(pagination, { ...filters, ...defaultFilters });
    }, []);

    const onPageChange = (_pagination) => {
        setPagination({ ..._pagination });
        fetchPayoutLinks({ ..._pagination }, filters);
    };

    // bulk_permission: 'TRANSFERS_BULK_UPLOAD'
    const CreateButton = CreatePermissionHoc({ create_permission: 'PAYOUT_LINKS_WRITE', bulk_permission: 'BULK_PAYOUT_LINKS' }, { onCreateClick: togglePayoutLinkModal, onBulkClick: toggleBulkUploadModal, createText: <><span className="mr-2" dangerouslySetInnerHTML={{ __html: `&#8377;` }} /> Payout Link</>, bulkText: "Bulk Payout Link" });
    return (
        <>
            {
                props.current_user.epl ?
                    <ContentCard className="p-3">
                        <div className="w-100 d-flex justify-content-end">
                            {/* <CreatePermissableButton type="primary" onClick={togglePayoutLinkModal}>
                                <Icon type="plus" /> New Payout Link
                            </CreatePermissableButton> */}
                            <CreateButton/>
                        </div>
                        <PayoutLinkModal
                            visible={showPayoutLinkModal}
                            toggleModal={togglePayoutLinkModal}
                            onSuccess={() => fetchPayoutLinks(pagination, filters)}
                        />
                        <EaseTable
                            rowKey="id"
                            loading={isTableLoading}
                            data={payoutLinks}
                            columns={tableColumns}
                            fixedSelectable={!isMobile}
                            handleTableChange={handleTableChange}
                            pagination={pagination}
                            totalRecords={pagination.total}
                            filterNodes={tableFilters}
                            downloadable={true}
                            onDownload={downloadReport}
                            isDownloading={isDownloading}
                        /><PaginationKaBaap pageChange={onPageChange} pagination={pagination} />
                        <PayoutLinkDetails
                            visible={showPayoutLinkDetailsDrawer}
                            onClose={togglePayoutLinkDetailsDrawer}
                            payoutLink={selectedPayoutLink}
                            deactivateLink={deactivateLink}
                            isDeactivating={isDeactivating}
                        />
                        <BulkUploadModal
                            history={props.history}
                            visible={showBulkUploadModal}
                            toggleBulkUploadModal={toggleBulkUploadModal}
                            onSuccess={() => fetchPayoutLinks(pagination, filters)}
                            type="payout_link"
                        />
                        <EaseDrawer
                            visible={showStatusInfoDrawer}
                            onClose={() => setShowStatusInfoDrawer(false)}
                            hideFooter
                            title="Payout Link Statuses"
                            width={500}
                        >
                            <Descriptions bordered className="mt-3" size="small" layout="horizontal" column={1}>
                                {
                                    Object.keys(PAYOUT_LINK_STATUS_TYPES).map((key, index) => {
                                        return <Descriptions.Item label={<Badge color={PAYOUT_LINK_STATUS_TYPES[key].color} text={<Text4>{PAYOUT_LINK_STATUS_TYPES[key].label}</Text4>} />}>
                                            {PAYOUT_LINK_STATUS_TYPES[key].description}
                                        </Descriptions.Item>
                                    })
                                }
                            </Descriptions>
                        </EaseDrawer>
                    </ContentCard>
                    :
                    <Alert
                        message="Unauthorized"
                        description="You are not authorized to view this page."
                        type="error"
                        showIcon
                    />
            }
        </>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

export default connect(mapStateToProps)(PermissionHoc(PayoutLinkList, 'PAYOUT_LINKS_READ'));